import React, { useState } from 'react'; // FIX: Removed useEffect
import './SongList.css'; 

const STRINGS = ['e', 'B', 'G', 'D', 'A', 'E'];
const MIN_SAVED_COLUMNS = 16;
const EDITOR_STEPS_PER_SYSTEM = 32;
const EXTEND_COLUMNS = 8;
const createEmptyGrid = () => Array(6).fill(null).map(() => Array(MIN_SAVED_COLUMNS).fill(""));
const parseInitialGrid = (initialData) => {
  if (!initialData) return createEmptyGrid();

  try {
    const parsed = JSON.parse(initialData);
    if (
      Array.isArray(parsed) &&
      parsed.length === 6 &&
      parsed.every(row => Array.isArray(row))
    ) {
      return parsed;
    }
  } catch (err) {
    console.error("Invalid tab data:", err);
  }

  return createEmptyGrid();
};

const TabBuilder = ({ initialData, onSave, onCancel }) => {
  const [grid, setGrid] = useState(() => parseInitialGrid(initialData));

  const totalCols = grid[0].length;
  const totalSystems = Math.ceil(totalCols / EDITOR_STEPS_PER_SYSTEM);

  const handleChange = (stringIndex, globalColIndex, value) => {
    if (value.length > 2) return; 

    const newGrid = grid.map((row, r) => {
      if (r !== stringIndex) return row;
      const newRow = [...row];
      newRow[globalColIndex] = value;
      return newRow;
    });
    setGrid(newGrid);
  };

  const addColumns = () => {
    const newGrid = grid.map(row => [
      ...row,
      ...Array(EXTEND_COLUMNS).fill("")
    ]);
    setGrid(newGrid);
  };

  // --- SMART SAVE LOGIC ---
  const handleSave = () => {
    let lastActiveColumn = -1;
    const currentTotalCols = grid[0].length;

    for (let c = currentTotalCols - 1; c >= 0; c--) {
      const hasData = grid.some(row => row[c] !== "");
      if (hasData) {
        lastActiveColumn = c;
        break; 
      }
    }

    const cutOffIndex = Math.max(lastActiveColumn + 1, MIN_SAVED_COLUMNS);
    const trimmedGrid = grid.map(row => row.slice(0, cutOffIndex));

    onSave(JSON.stringify(trimmedGrid));
  };

  return (
    <div className="tab-builder-container">
      <div className="tab-header">
        <h4>Guitar Riff Editor</h4>
        <div style={{display:'flex', gap:'10px'}}>
             <button className="btn-success" onClick={handleSave} style={{padding:'5px 10px', fontSize:'0.8rem'}}>Save Riff</button>
             <button className="btn-danger" onClick={onCancel} style={{padding:'5px 10px', fontSize:'0.8rem'}}>Cancel</button>
        </div>
      </div>

      <div className="tab-scroll-wrapper">
        {Array.from({ length: totalSystems }).map((_, systemIndex) => (
          <div key={systemIndex} className="tab-system">
            {STRINGS.map((stringName, stringIndex) => (
              <div key={stringIndex} className="tab-string-row">
                <div className="string-name">{stringName}</div>
                {grid[stringIndex]
                  .slice(systemIndex * EDITOR_STEPS_PER_SYSTEM, (systemIndex + 1) * EDITOR_STEPS_PER_SYSTEM)
                  .map((cell, localColIndex) => {
                    const globalColIndex = (systemIndex * EDITOR_STEPS_PER_SYSTEM) + localColIndex;
                    
                    return (
                      <div key={globalColIndex} className="tab-cell-wrapper">
                        <div className="tab-line"></div>
                        <input
                          className="tab-input"
                          value={grid[stringIndex][globalColIndex] || ""}
                          onChange={(e) => handleChange(stringIndex, globalColIndex, e.target.value)}
                        />
                      </div>
                    );
                  })}
              </div>
            ))}
          </div>
        ))}
      </div>
      
      <button className="btn-text-toggle" onClick={addColumns} style={{marginTop:'10px'}}>
        + Extend Tab
      </button>
    </div>
  );
};

export default TabBuilder;
